import { useTranslation } from 'react-i18next';

// Required by Geoapify's free plan and by OpenStreetMap's licence wherever the address lookup is shown.
const AddressAttribution = () => {
  const { t } = useTranslation();

  return (
    <span>
      {t('common.addresssearchpoweredby')}{' '}
      <a href="https://www.geoapify.com/" target="_blank" rel="noreferrer">Geoapify</a>
    </span>
  );
};

export default AddressAttribution;
